import React from "react"
import Hero from "../components/home-page/hero"
import Features from "../components/home-page/features"
import FAQ from "../components/home-page/faq"
import Footer from "../components/footer/footer"
import Layout from "../components/layout/layout"

const LandingPage = () => {
  return (
    <Layout darkLogo={true}>
      <Hero />
      <Features />
      <FAQ />
      <Footer />
    </Layout>
  )
}

export default LandingPage
